
import { AxiosError, EQLSearchSignedClass, MapResponseFn } from "@eco/client";
import useEcoClient from "hooks/useEcoClient";
import { useCallback, useMemo } from "react";
import useEcoQuery, { UseEcoQueryOptions } from "./useEcoQuery";
import { useEqlSearchSignedQuery } from "./useEqlSearchSignedQuery";



/**
 * 
 * Custom hook to query Ecomundo EQL API   
 * 
 * @param query object containing eql query
 * @param mapResponseFn mapping function for API response
 * @param config to pass to reactQuery
 * 
 */

export const useEqlSearch = <TData, TClass extends EQLSearchSignedClass, TRawData = unknown> (
    query: TClass,
    mapResponseFn?: MapResponseFn<TData, TRawData>,
    config?: UseEcoQueryOptions<unknown, TData, AxiosError>
) => 
{
    const cacheKey = useMemo(() => [query.cacheKey, query.variables], [query])
    const ecoClient = useEcoClient() ;
    const signedQuery = useEqlSearchSignedQuery(query)

    const queryFn = useCallback( async (): Promise<TData> => {
        return ecoClient.eql<TData, TClass['parameters'], TRawData>(signedQuery, mapResponseFn)
    }, [query])
    
    return useEcoQuery(cacheKey, queryFn, { enabled: query !== undefined, ...config})
}
